function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import SignupFormComponent from "/components/core/signups/base-signup-form/signup-form-component";
import { LOGIN_PAGE_LINK } from "constants/links";
import { TOPBAR_LOGIN_BUTTON_CLASS } from "constants/topbar-selectors";
import OutlineButtonComponent from "../../outline-button/outline-button-component";
import { withGenericConfig } from "contexts/generic-config-context";
import { StyledTopbarLoginSignupComponent } from "./topbar-login-signup-component.scss";
class TopbarLoginSignupComponent extends PureComponent {
    render() {
        const { loginUrl, theme, isInScrollMode, signupTrackingPlacement, translate, buttonText, inputPlaceholder } = this.props;
        const buttonTextToUse = buttonText || translate("signup.signup");
        const inputPlaceholderToUse = inputPlaceholder || translate("signup.emailInputShortPlaceholder");
        return /*#__PURE__*/ _jsxs(StyledTopbarLoginSignupComponent, {
            className: "topbar-login-signup-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "topbar-login-signup-seperator"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "topbar-login-signup-login-button-wrapper",
                    children: /*#__PURE__*/ _jsx(OutlineButtonComponent, {
                        url: loginUrl || LOGIN_PAGE_LINK,
                        text: translate("signup.logIn"),
                        theme: theme,
                        isInScrollMode: isInScrollMode,
                        buttonStyle: "textual",
                        linkClassName: `${TOPBAR_LOGIN_BUTTON_CLASS} login-top-bar`
                    })
                }),
                isInScrollMode && /*#__PURE__*/ _jsx("div", {
                    className: "topbar-login-signup-base-signup-wrapper",
                    children: /*#__PURE__*/ _jsx(SignupFormComponent, _object_spread_props(_object_spread({}, this.props), {
                        ctaText: buttonTextToUse,
                        useCtaText: !!buttonTextToUse,
                        inputPlaceholder: inputPlaceholderToUse,
                        preventErrorMessage: true,
                        placement: signupTrackingPlacement
                    }))
                })
            ]
        });
    }
}
TopbarLoginSignupComponent.defaultProps = {
    signupTrackingPlacement: "topbar"
};
export default withGenericConfig(TopbarLoginSignupComponent);
